// 定义汉化文本
export const localizedStrings = {
    'commands': {
      'sqrt': '根号',
    'frac': '分数',
    'sin': '正弦',
    'cos': '余弦',
    'tan': '正切',
    'pi': '圆周率',
    'int': '积分',
    'sum': '求和',
    'prod': '连乘积',
    'log': '对数',
    'lim': '极限',
    'det': '行列式',
    'dim': '维度',
    'mod': '模',
    'gcd': '最大公约数',
    'lcm': '最小公倍数',
    'vec': '向量',
    'dot': '点积',
    'cross': '叉积',
    'curl': '旋度',
    'div': '散度',
    'grad': '梯度',
    'exp': '指数',
    'max': '最大值',
    'min': '最小值',
    'argmax': '最大值点',
    'argmin': '最小值点',
      // ...其他需要汉化的命令
    },
    'keyboard': {
      'tooltip': {
        'command': '命令',
        'ctrl': '控制',
        'shift': '上档',
        'space': '空格',
        // ...其他需要汉化的键盘提示
      },
      // ...其他需要汉化的键盘文本
    },
    // ...其他需要汉化的文本部分
  }
  
  